"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _classnames = _interopRequireDefault(require("classnames"));

var _shortid = _interopRequireDefault(require("shortid"));

var _reactPopperTooltip = _interopRequireDefault(require("react-popper-tooltip"));

var _excluded = ["className", "tooltip", "children", "id", "trigger"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var CSS_PREFIX = 'vds-tooltip';
var CSS_STATE = 'vds-state';

var Tooltip = function Tooltip(_ref) {
  var className = _ref.className,
      _tooltip = _ref.tooltip,
      children = _ref.children,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? _shortid.default.generate() : _ref$id,
      trigger = _ref.trigger,
      remainingProps = _objectWithoutProperties(_ref, _excluded);

  var uniqueId = (0, _react.useRef)(id);
  var uid = uniqueId.current;
  return /*#__PURE__*/_react.default.createElement(_reactPopperTooltip.default, _extends({
    trigger: trigger
  }, remainingProps, {
    modifiers: {
      offset: {
        enabled: true,
        offset: '0, 4px'
      }
    },
    tooltip: function tooltip(_ref2) {
      var getTooltipProps = _ref2.getTooltipProps,
          tooltipRef = _ref2.tooltipRef;
      return /*#__PURE__*/_react.default.createElement("div", _extends({
        hidden: true
      }, getTooltipProps({
        className: (0, _classnames.default)(CSS_PREFIX, "".concat(CSS_STATE, "--show"), className),
        ref: tooltipRef
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "".concat(CSS_PREFIX, "-content")
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "".concat(CSS_PREFIX, "-text")
      }, _tooltip), /*#__PURE__*/_react.default.createElement("span", {
        className: "".concat(CSS_PREFIX, "-pointer")
      })));
    }
  }), function (_ref3) {
    var getTriggerProps = _ref3.getTriggerProps,
        triggerRef = _ref3.triggerRef;
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, (0, _react.cloneElement)(children, _objectSpread({}, getTriggerProps({
      'aria-controls': children.props['aria-controls'] ? children.props['aria-controls'] : uid,
      'aria-describedby': children.props['aria-describedby'] ? children.props['aria-describedby'] : uid,
      ref: triggerRef
    }))), /*#__PURE__*/_react.default.createElement("span", {
      "aria-hidden": "true",
      id: uid,
      style: {
        display: 'none'
      }
    }, _tooltip));
  });
};

Tooltip.propTypes = {
  /**
  * @ignore
  */
  children: _propTypes.node,

  /**
   * @ignore
   */
  className: _propTypes.string,

  /**
   * ID
   */
  id: (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string]),

  /**
   * Popper Placement
   */
  placement: (0, _propTypes.oneOf)(['auto', 'bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top']),

  /**
   * Tooltip
   */
  tooltip: _propTypes.node.isRequired,

  /**
   * Trigger
   */
  trigger: (0, _propTypes.oneOfType)([(0, _propTypes.oneOf)(['click', 'hover', 'right-click', 'focus', 'none']), (0, _propTypes.arrayOf)((0, _propTypes.oneOf)(['click', 'hover', 'right-click', 'focus', 'none']))])
};
Tooltip.displayName = 'Tooltip';
var _default = Tooltip;
exports.default = _default;